module.exports = __webpack_public_path__ + "images/briefing-holder-3619a1e3b7b790ab4035b94b64d0bb77.svg";